import RelatorioFinanceiro from './RelatorioFinanceiro';

export default RelatorioFinanceiro;